/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_3_TitleInputs */

const en_vc_ft_3_title = /** @type {(inputs: Vc_Ft_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Blends, Layers and Appearance`)
};

const zh_vc_ft_3_title = /** @type {(inputs: Vc_Ft_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时混合、图层与外观`)
};

/**
* | output |
* | --- |
* | "Live Blends, Layers and Appearance" |
*
* @param {Vc_Ft_3_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_3_title = /** @type {((inputs?: Vc_Ft_3_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_3_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_3_title(inputs)
	return zh_vc_ft_3_title(inputs)
});
export { vc_ft_3_title as "vc.ft.3.title" }